const CompraTransaccionesCard = ({ originalOrder, order, irCompra, index }) => {
    return <article key={index} className={originalOrder.compra_id === order.com_id ? "itemOculto" : 'Sombra m-2'} onClick={() => irCompra(order)}>
        <div className={order.color ? order.color : 'naranja'} style={{ height: '30%', minHeight: '130px' }}>
            <h3>
                {'#' + order.com_id + ' | ' + order.com_proveedor}
            </h3>
            <p>
                {"(" + order.com_estado + ") " + order.com_fecha_entrega}
            </p>
        </div>
        {order.products && order.products.map((producto, prodIndex) =>
            <b key={prodIndex} className='compraResumenListaProductos'>
                <img src={producto.prv_foto_link} alt="Img Prod" />
                <span>
                    {producto.full_name + " x" + producto.cor_cantidad}
                </span>
            </b>
        )}
    </article>
}

export default CompraTransaccionesCard;